var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJackrusselTryagain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.69 197.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #262626;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-6, .cls-3 {\n        stroke-width: 2.47px;\n      }\n\n      .cls-1, .cls-6, .cls-3, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-5, .cls-14 {\n        stroke: #1d1d1b;\n      }\n\n      .cls-2 {\n        stroke: #f4bd22;\n        stroke-width: 6px;\n      }\n\n      .cls-2, .cls-6, .cls-3, .cls-7, .cls-9, .cls-10, .cls-4, .cls-11, .cls-14 {\n        fill: none;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-15, .cls-8 {\n        fill: #f4bd22;\n      }\n\n      .cls-16, .cls-12, .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-17 {\n        fill: #dadada;\n      }\n\n      .cls-18 {\n        fill: #e16e2d;\n      }\n\n      .cls-19 {\n        fill: #1e1e1e;\n      }\n\n      .cls-20 {\n        fill: #202020;\n      }\n\n      .cls-21 {\n        fill: #575756;\n      }\n\n      .cls-22 {\n        fill: #3c3c3b;\n      }\n\n      .cls-7 {\n        stroke-width: 2.9px;\n      }\n\n      .cls-8 {\n        stroke-width: 1.11px;\n      }\n\n      .cls-9 {\n        stroke-width: 2.61px;\n      }\n\n      .cls-10 {\n        stroke-width: 2.68px;\n      }\n\n      .cls-4 {\n        stroke: #dadada;\n        stroke-width: 2.64px;\n      }\n\n      .cls-11 {\n        stroke-width: 2.16px;\n      }\n\n      .cls-12 {\n        stroke-width: 2.29px;\n      }\n\n      .cls-13, .cls-14 {\n        stroke-width: 3px;\n      }\n\n      .cls-5 {\n        fill: #1d1d1b;\n        stroke-width: 1.47px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ombra"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 70.44,
    cy: 189.81,
    rx: 70.44,
    ry: 5.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 166.94,
    cy: 195.33,
    rx: 17.75,
    ry: 1.74
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "coda"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Coda",
    className: "cls-13",
    d: "M54.96,164.97c-5.42-.89-9.82-3.5-13.65-9.65-3.8-6.09-6.15-11.78-7.64-16.27-1.65,1.29-5.81,4.92-7.06,10.92-.13,.62-.96,3-.18,5.95,.72,2.73,3.16,10.55,10.92,16.71,5.8,4.61,11.91,6.14,15.57,6.74"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Corpo_fronte",
    "data-name": "Corpo fronte"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M110.04,94.04c12.72,23.2,17.28,52.09,17.78,63.03,.86,18.52-3.87,24.35-7.17,27.02-4.31,3.48-9.54,4.27-13.02,4.41-11.24-.1-22.48-.2-33.72-.3-3.56-.26-10.21-1.3-15.22-6.15-4.97-4.82-6.25-11.41-6.35-19.56-.28-23.34,14.18-58.99,18.52-70.03,15.35,.7,23.83,.9,39.18,1.59Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_post._fronte_destra",
    "data-name": "Zampa post. fronte destra"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M56.64,141.24c-4.12,.5-11.1,8.15-10.81,30.26,.19,14.52,3.84,16.46,3.84,16.46h23.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M56.64,141.24c-4.12,.5-11.1,8.15-10.81,30.26,.19,14.52,3.84,16.46,3.84,16.46h23.42"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_post._fronte_sinistra",
    "data-name": "Zampa post. fronte sinistra"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M125.13,142.24c4.12,.5,11.1,8.15,10.81,30.26-.19,14.52-3.84,16.46-3.84,16.46h-23.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.13,142.24c4.12,.5,11.1,8.15,10.81,30.26-.19,14.52-3.84,16.46-3.84,16.46h-23.42"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Collare_fronte",
    "data-name": "Collare fronte"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Collare"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M115.86,103.26c-4.92,1.65-13.55,3.86-24.36,3-11.15-.89-19.52-4.64-24.13-7.13,.41-5.18,.82-10.36,1.22-15.54,3.81,2.7,10.68,6.8,20.17,8.62,12.64,2.42,22.88-.56,27.5-2.23-.13,4.43-.27,8.85-.4,13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M115.86,103.26c-4.92,1.65-13.55,3.86-24.36,3-11.15-.89-19.52-4.64-24.13-7.13,.41-5.18,.82-10.36,1.22-15.54,3.81,2.7,10.68,6.8,20.17,8.62,12.64,2.42,22.88-.56,27.5-2.23-.13,4.43-.27,8.85-.4,13.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.78,91.16l-2.74,17.33c-.17,1.06-.04,2.04,.42,2.25,.54,.25,1.68-.5,2.53-2.09l2.92-17.34-3.14-.15Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Medaglietta"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M75.93,121.27l5.91,.77c0,.21,.06,1.6,1.2,2.52,1.03,.83,2.54,.94,3.71,.22,1.15-.7,1.75-2.05,1.52-3.34-.27-1.5-1.54-2.21-1.71-2.3,.17-.04,1.66-.39,2.3-1.82,.55-1.24,.21-2.69-.72-3.61-.93-.92-2.34-1.22-3.55-.72-1.42,.58-1.85,1.98-1.9,2.17l-5.87-.76c0-.26-.05-1.45-.98-2.34-1-.95-2.59-1.13-3.82-.45-.99,.55-1.67,1.61-1.68,2.82-.01,1.19,.63,2.29,1.66,2.88-.33,.08-1.26,.36-1.88,1.23-.84,1.17-.79,2.96,.27,4.11,.82,.89,2.14,1.29,3.37,.9,1.63-.52,2.11-2.13,2.15-2.25Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Orecchio_sinistro",
    "data-name": "Orecchio sinistro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orecchio_sinistro-2",
    "data-name": "Orecchio sinistro"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M81.91,30.82c6.5-9.86,12.99-19.72,19.49-29.59,1.65,2.71,4.37,7.96,5.11,15.14,.76,7.42-.96,13.28-2.07,16.28-.87,2.01-1.74,4.02-2.61,6.03l-19.92-7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.91,30.82c6.5-9.86,12.99-19.72,19.49-29.59,1.65,2.71,4.37,7.96,5.11,15.14,.76,7.42-.96,13.28-2.07,16.28-.87,2.01-1.74,4.02-2.61,6.03l-19.92-7.86Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._fronte_sinistra",
    "data-name": "Zampa ant. fronte sinistra"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._destra",
    "data-name": "Zampa ant. destra"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M120.32,131.14c-3.35,20.33-6.7,40.65-10.06,60.98-6.28,.02-12.56,.04-18.84,.05,.96-15.97,1.91-31.93,2.87-47.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._destra-2",
    "data-name": "Zampa ant. destra"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M120.32,131.14c-3.35,20.33-6.7,40.65-10.06,60.98-6.28,.02-12.56,.04-18.84,.05,.96-15.97,1.91-31.93,2.87-47.9"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._fronte_destra",
    "data-name": "Zampa ant. fronte destra"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._destra-3",
    "data-name": "Zampa ant. destra"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M60.64,131.01c3.07,20.35,6.14,40.71,9.21,61.06,5.87,.08,11.73,.15,17.6,.23-.84-15.97-1.69-31.94-2.53-47.91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._destra-4",
    "data-name": "Zampa ant. destra"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.64,131.01c3.07,20.35,6.14,40.71,9.21,61.06,5.87,.08,11.73,.15,17.6,.23-.84-15.97-1.69-31.94-2.53-47.91"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "guinzaglio"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M125.97,108.04c-.27,4.07,3.03,7.41,6.73,7.32,3.38-.09,6.34-3.02,6.4-6.73-.29-1.92-.92-4.59-2.41-7.48-.39-.76-.81-1.46-1.22-2.1-.94-1.44-2.94-1.65-4.2-.48-.84,.79-1.73,1.78-2.56,2.99-1.74,2.56-2.44,5.01-2.74,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M166.28,169.16c.27-4.07-3.03-7.41-6.73-7.32-3.38,.09-6.34,3.02-6.4,6.73,.29,1.92,.92,4.59,2.41,7.48,.39,.76,.81,1.46,1.22,2.1,.94,1.44,2.94,1.65,4.2,.48,.84-.79,1.73-1.78,2.56-2.99,1.74-2.56,2.44-5.01,2.74-6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.14,170.34s3.35-45.61-4.85-75.1-19.29-5.1-21.28,4.43,8.5,27.6,10.03,37.3c1.75,11.1-4.24,25.09-13.58,22.78-8.15-2.01-16.79-8.81-11.69-30.87,2.61-11.31,17.24-25.66,17.24-25.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M124.81,107.82c-.27,4.07,3.03,7.41,6.73,7.32,3.38-.09,6.34-3.02,6.4-6.73-.29-1.92-.92-4.59-2.41-7.48-.39-.76-.81-1.46-1.22-2.1-.94-1.44-2.94-1.65-4.2-.48-.84,.79-1.73,1.78-2.56,2.99-1.74,2.56-2.44,5.01-2.74,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M165.11,169.74c.27-4.07-3.03-7.41-6.73-7.32-3.38,.09-6.34,3.02-6.4,6.73,.29,1.92,.92,4.59,2.41,7.48,.39,.76,.81,1.46,1.22,2.1,.94,1.44,2.94,1.65,4.2,.48,.84-.79,1.73-1.78,2.56-2.99,1.74-2.56,2.44-5.01,2.74-6.48Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_210",
    "data-name": "Raggruppa 210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_209",
    "data-name": "Raggruppa 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_207",
    "data-name": "Raggruppa 207",
    transform: "translate(0.024 512.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_352",
    "data-name": "Tracciato 352",
    className: "cls-15",
    d: "M132.61,107.77s-.08-.05-.07-.09l.05-.48c-.08,.07-.18,.18-.21,.19-.08,.05-.16,.11-.24,.14-.19,.08-.38,.13-.59,.12-.46-.01-.84-.15-1.13-.5-.6,.43-1.56,.44-1.99-.24-.29-.45-.28-.95-.24-1.45v-.02c.07-.82,.19-1.73,.25-2.56,0-.04,.04-.08,.09-.07l1.47,.14s.08,.05,.07,.1c-.1,.87-.17,1.73-.25,2.61-.04,.38,.54,.4,.59-.03,0-.09,.03-.19,.03-.28l.08-.82c.03-.44,.11-1.01,.14-1.45,0-.04,.04-.08,.09-.07l1.5,.15s.09,.05,.07,.1c-.05,.46-.08,.92-.13,1.38-.03,.29-.07,.59-.09,.88-.02,.21-.11,.57,.25,.61s.36-.38,.38-.6l.22-2.22s.05-.09,.09-.07l1.39,.14s.08,.04,.07,.09l-.42,4.36s-.04,.08-.09,.07l-1.39-.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_208",
    "data-name": "Raggruppa 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_353",
    "data-name": "Tracciato 353",
    className: "cls-15",
    d: "M129.78,110.09l.38,.03,.76,.09c.18,.02,.34,.18,.51,.25l.24,.09c.08,.02,.16,.04,.24,.04l-.07,.75s.01,.09,.04,.12c.03,.03,.07,.05,.11,.05,.36,0,.67-.27,.7-.63l.02-.21h.15l.12,.03-.07,.74s0,.09,.04,.12c.03,.03,.07,.05,.12,.05,.36,0,.67-.27,.7-.63l.21-2.16h0l.02-.23s-.02-.09-.07-.09l-1.59-.16c-.83-.08-1.44-.1-1.92,.17-.22,.12-.39,.3-.52,.5-.15,.23-.23,.49-.26,.76v.13c-.02,.09,.04,.16,.13,.17h0Zm2.87-.51c.16,.02,.28,.16,.26,.32-.02,.16-.16,.28-.32,.26-.16-.02-.28-.16-.26-.32h0c.02-.16,.16-.28,.32-.26Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_215",
    "data-name": "Raggruppa 215",
    transform: "translate(538.441 175.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_211",
    "data-name": "Raggruppa 211",
    transform: "translate(48.001 132.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_354",
    "data-name": "Tracciato 354",
    className: "cls-16",
    d: "M129.3,107.87s.04,.05,.02,.07h0c-.16,.25-.1,.58,.14,.74,.04,.03,.09,.05,.14,.07,.03,0,.04,.04,.04,.07h0l-.06,.14s-.04,.04-.07,.03c-.41-.14-.62-.58-.49-.99,.02-.06,.05-.12,.08-.17,.01-.02,.04-.03,.07-.02l.13,.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_212",
    "data-name": "Raggruppa 212",
    transform: "translate(72.708 68.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_355",
    "data-name": "Tracciato 355",
    className: "cls-16",
    d: "M128.84,107.66s.04,.05,.02,.07h0c-.29,.49-.13,1.12,.36,1.4,.05,.03,.1,.06,.16,.08,.03,.01,.04,.04,.03,.07h0l-.06,.13s-.04,.04-.07,.03c-.15-.06-.3-.15-.42-.26-.29-.28-.44-.69-.38-1.09,.02-.16,.08-.32,.16-.47,.01-.02,.04-.03,.07-.02l.13,.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_213",
    "data-name": "Raggruppa 213",
    transform: "translate(96.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_356",
    "data-name": "Tracciato 356",
    className: "cls-16",
    d: "M128.35,107.42s.04,.04,.02,.07h0c-.42,.75-.15,1.7,.6,2.12,.06,.03,.11,.06,.17,.08,.03,.01,.04,.04,.03,.07h0l-.06,.13s-.04,.04-.07,.03c-.92-.38-1.36-1.44-.98-2.36,.03-.06,.06-.13,.09-.19,.01-.02,.04-.03,.07-.02l.13,.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_214",
    "data-name": "Raggruppa 214",
    transform: "translate(0 208.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_357",
    "data-name": "Tracciato 357",
    className: "cls-16",
    d: "M130.04,108.15c.04,.12-.02,.25-.14,.29-.12,.04-.25-.02-.29-.14-.04-.12,.02-.25,.14-.29h0c.12-.04,.25,.02,.29,.14Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M158.1,180.46c8.32,1.06,16.83,2.2,25.22,3.51,.55,.09,.96,.53,1.02,1.05,.14,1.22,.17,2.36,.11,3.56-.22,4.92-2.58,7.34-7.62,6.84-6.27-.5-10.73-4.35-6.31-10.44,0-.02,.72,2.01,.72,2.01l-12.89-2.41c-1.86-.5-.62-2.95-.27-4.11h0Zm1.48,1.97c.16,.47,.29,.74,.23,1.08l-1-1.37,12.89,2.41c.92,.15,1.32,1.32,.72,2.01-.47,1.22-.92,2.71-.12,3.72,1.75,1.01,5.12,1.61,7.14,1.03,.37-.17,.38-.13,.65-.61,.87-1.63,1.13-3.54,1.8-5.36l1.04,1.05c-7.8-1.19-15.48-2.54-23.35-3.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.07,156.21s1.43-3.8-1.27-4.36c-5.12-1.06-9.02,12.46-5.32,13.72,3.06,1.04,4.8-3.66,4.8-3.66"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "testa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Testa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M72.74,87.12c5.52,2.31,12.33,4.67,20.28,6.42,7.1,1.56,13.55,2.29,19.05,2.59,7.34,.39,18.08,.28,29.36-5.62,9.68-5.07,15.63-12.44,18.96-17.62,1.5-2.61,3.27-6.33,4.4-11.04,.84-3.52,1.1-6.66,1.13-9.17-28.26-8.2-56.52-16.41-84.78-24.61-1.9,.83-15.94,7.25-20.15,22.87-3.48,12.91,1.12,27.03,11.75,36.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M110.46,61.04c-.71,8.91-8.85,17.57-16.48,21.51-2.24,1.16-5.74,2.62-10.23,3.2-5.86,.76-10.61-.34-13.28-1.18-2.73-4.17-5.45-8.34-8.18-12.51l-1.89-17.1,5.7-14.4c2.07-2.32,4.13-4.63,6.19-6.95,1.45-.83,2.91-1.66,4.36-2.49,21.25,2.19,34.81,17.37,33.81,29.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "96.23 32.89 150.94 57.15 165.91 52.67 96.23 32.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.74,87.12c5.52,2.31,12.33,4.67,20.28,6.42,7.1,1.56,13.55,2.29,19.05,2.59,7.34,.39,18.08,.28,29.36-5.62,9.68-5.07,15.63-12.44,18.96-17.62,1.5-2.61,3.27-6.33,4.4-11.04,.84-3.52,1.1-6.66,1.13-9.17-28.26-8.2-56.52-16.41-84.78-24.61-1.9,.83-15.94,7.25-20.15,22.87-3.48,12.91,1.12,27.03,11.75,36.19Z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Occhio_chiuso",
    "data-name": "Occhio chiuso"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Occhio_chiuso-2",
    "data-name": "Occhio chiuso",
    className: "cls-11",
    d: "M98.12,57.39c-1.66-1.13-7.17-4.55-14.13-3.08-6.67,1.4-10.59,6.42-11.82,8.15"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "naso"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Naso",
    className: "cls-1",
    d: "M165.22,53.38l-22.67,7.69c2.05,4.94,6.21,8.46,10.48,8.58,6.2,.18,13-6.77,12.2-16.27Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Orecchio_destro",
    "data-name": "Orecchio destro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orecchio_destro-2",
    "data-name": "Orecchio destro"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M79.62,35.74l-25.1-12.3c-2.74,2.55-8.44,8.56-11.27,18.2-3.37,11.47-.62,21.07,.56,24.53,3.22,5.25,5.49,6.04,6.92,5.9,4.24-.41,4.9-9.44,12.7-19.81,2.91-3.87,5.82-6.6,7.7-8.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.62,35.74l-25.1-12.3c-2.42,2.09-8.71,8.09-11.27,18.2-2.23,8.79-.46,16.06,.49,19.19,3.06,9.52,5.43,11.28,6.98,11.25,3.47-.07,4.45-9.1,12.7-19.81,2.96-3.85,5.85-6.59,7.7-8.22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackrusselTryagain);
export default __webpack_public_path__ + "static/media/jackrussel_tryagain.73c72ac32458629d968f621e35dc93e8.svg";
export { ForwardRef as ReactComponent };